import { GetAPIService } from "../services";

//  handler to save all steps data
export const createdVisitedUser = () => {
  return GetAPIService(`/visitors/create`);
};
